import { useEffect, useState } from "react";
import { apiGet } from "../../api";

/** The text size invoices print at, set once for the firm.
 *
 * Falls back to the size the invoices were designed at if the setting cannot
 * be read: an invoice that renders at the wrong size is recoverable, one that
 * does not render at all is not.
 */
export const DESIGN_FONT_SIZE = 13;

export default function useInvoiceFontSize() {
  const [fontSize, setFontSize] = useState(DESIGN_FONT_SIZE);
  useEffect(() => {
    let cancelled = false;
    apiGet("/api/firm-settings/")
      .then((s) => {
        const value = Number(s?.invoice_font_size);
        if (!cancelled && value > 0) setFontSize(value);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return fontSize;
}
